import React from 'react';
import css from './ProfilePage.module.css';
import Icons from '../../components/Icons/Icons';
import { FormattedMessage } from 'react-intl';
import { H4 } from '../../components';

import {
  buildingSystemOptions,
  companyAccrediationsOptions,
  structuralWarrantyProviderOptions,
} from '../../util/general';

import { getLabelFromKey, isArrayLength } from '../../util/genericHelpers';

const renderArraySection = (headingId, keys, options) => {
  if (!isArrayLength(keys)) return null;
  return (
    <>
      <H4 as="h4">
        <FormattedMessage id={headingId} />
      </H4>
      <div className={css.serviceList}>
        {keys.map((key, i) => (
          <div key={i} className={css.service}>
            <Icons name="check" /> {getLabelFromKey(key, options)}
          </div>
        ))}
      </div>
    </>
  );
};

const renderSingleValueSection = (headingId, value, options) => {
  if (!value) return null;
  return (
    <>
      <H4 as="h4">
        <FormattedMessage id={headingId} />
      </H4>
      <div className={css.serviceList}>
        <div className={css.service}>
          <Icons name="check" /> {getLabelFromKey(value, options)}
        </div>
      </div>
    </>
  );
};

const renderRawString = (headingId, value) => {
  if (!value) return null;
  return (
    <>
      <H4 as="h4">
        <FormattedMessage id={headingId} />
      </H4>
      <div className={css.serviceList}>
        <div className={css.service}>
          <Icons name="check" /> {value}
        </div>
      </div>
    </>
  );
};

const OffsiteCompanyProfileSection = ({ publicData = {} }) => {
  const {
    buildingSystemUsed,
    companyAccrediations,
    structuralWarrantyProvider,
    companyAwards,
    inhouseDesigners,
  } = publicData;

  return (
    <div className={css.infoBlock}>
      <h2>
        <FormattedMessage id="ProfilePage.companyProfileHeading" />
      </h2>
      {renderArraySection(
        'ProfilePage.buildingSystemUsed.heading',
        buildingSystemUsed,
        buildingSystemOptions
      )}
      {renderArraySection(
        'ProfilePage.companyAccrediations.heading',
        companyAccrediations,
        companyAccrediationsOptions
      )}

      {renderArraySection(
        'ProfilePage.structuralWarrantyProvider.heading',
        structuralWarrantyProvider,
        structuralWarrantyProviderOptions
      )}
      {renderSingleValueSection('ProfilePage.inhouseDesigners.heading', inhouseDesigners, [
        { key: 'yes', label: 'Yes' },
        { key: 'no', label: 'No' },
      ])}
      {renderRawString('ProfilePage.companyAwards.heading', companyAwards)}
    </div>
  );
};

export default OffsiteCompanyProfileSection;
